export default "__VITE_ASSET__zKoN9GbH__"